import React from 'react';

const Copyright = () => {
    return (
        <main style={{ maxWidth: 800, margin: '0 auto', padding: '2rem' }}>
            <h1>The Crumb Explorer – Copyright & Content Policy</h1>
            <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>

            <section>
                <h2>1. Ownership of the App</h2>
                <p>
                    The Crumb Explorer and its associated branding, interface, and original content
                    (excluding NFTs, tokens, user-generated content, and third-party materials) are
                    owned and operated by <strong>Kyle Hinton – The Simulacrum</strong>.
                </p>
                <p>
                    Unless otherwise stated, all rights in and to the App’s code, design, logos,
                    copy, and visual elements are reserved and protected by applicable intellectual
                    property laws.
                </p>
            </section>

            <section>
                <h2>2. Third-Party Content & NFTs</h2>
                <p>
                    The App displays information and media sourced from the Solana blockchain and
                    other third-party services. This includes, but is not limited to:
                </p>
                <ul>
                    <li>NFT images, animations, and metadata.</li>
                    <li>Token names, symbols, and balances.</li>
                    <li>Transaction data and account activity.</li>
                </ul>
                <p>
                    We do not claim ownership over any NFTs, tokens, or other assets displayed in
                    the App. Ownership of such content remains with the respective holders and/or
                    original creators, as determined by the underlying smart contracts and applicable
                    law.
                </p>
            </section>

            <section>
                <h2>3. Limited License to Use the App</h2>
                <p>
                    Subject to your compliance with our Terms of Use, we grant you a limited,
                    non-exclusive, non-transferable, revocable license to access and use the App
                    for your personal or internal business purposes.
                </p>
                <p>
                    You may not:
                </p>
                <ul>
                    <li>Copy, reproduce, modify, or distribute the App or its original content except as permitted by law.</li>
                    <li>Use our logos, branding, or trademarks without prior written permission.</li>
                    <li>Reverse engineer or attempt to extract the source code of proprietary components, except where allowed by applicable law.</li>
                </ul>
            </section>

            <section>
                <h2>4. Trademarks</h2>
                <p>
                    Any names, logos, or other marks used within the App that identify
                    <strong> The Simulacrum</strong> or “The Crumb Explorer” may be trademarks or service
                    marks of their respective owners. They may not be used without prior written
                    consent or except as allowed under applicable law.
                </p>
            </section>

            <section>
                <h2>5. Infringement & Takedown Requests</h2>
                <p>
                    If you believe that any content displayed in the App infringes your intellectual
                    property rights, please contact us with sufficient detail so we can assess the
                    request. Include:
                </p>
                <ul>
                    <li>Your name and contact information.</li>
                    <li>A description of the allegedly infringing content.</li>
                    <li>Evidence of your rights in the content.</li>
                    <li>Any relevant links (e.g., mint address, NFT collection, on-chain account, etc.).</li>
                </ul>
                <p>
                    We may forward your request to the relevant NFT creator, marketplace, or service
                    provider, and we reserve the right—but not the obligation—to hide or de-emphasize
                    content in our interface where appropriate.
                </p>
            </section>

            <section>
                <h2>6. Open Source & Third-Party Libraries</h2>
                <p>
                    The App may use open-source libraries and frameworks that are licensed under
                    separate terms. Those licenses govern your use of such components. References
                    to third-party libraries, tools, or services do not imply any endorsement,
                    sponsorship, or affiliation.
                </p>
            </section>

            <section>
                <h2>7. Changes to This Policy</h2>
                <p>
                    We may update this Copyright & Content Policy from time to time. When we do,
                    we will update the “Last updated” date above. Continued use of the App after
                    changes become effective constitutes your acceptance of the revised policy.
                </p>
            </section>

            <section>
                <h2>8. Contact</h2>
                <p>
                    For copyright or content-related questions, contact:
                </p>
                <p>
                    Email: <a href="mailto:kyle-hinton@outlook.com">kyle-hinton@outlook.com</a><br />
                    Website: <a href="https://thesimulacrum.xyz/" target="_blank" rel="noreferrer">
                    https://thesimulacrum.xyz/
                </a>
                </p>
            </section>
        </main>
    );
};

export default Copyright;
